<!--
  Mention Empty State Component

  Reusable empty state for mentions with customizable icon and text.
-->

<script setup lang="ts">
  defineOptions({ name: 'MentionEmptyState' })

  import { computed } from 'vue'
  import CPText from '@packages/ui/components/CPText.vue'
  import { Users01Icon, CalendarIcon, GraduationHat02Icon, Hash02Icon } from '@gohighlevel/ghl-icons/24/outline'

  const props = defineProps({
    iconType: {
      type: String as () => 'user' | 'event' | 'course' | 'channel',
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  })

  // Map icon type to component
  const iconComponent = computed(() => {
    switch (props.iconType) {
      case 'user':
        return Users01Icon
      case 'event':
        return CalendarIcon
      case 'course':
        return GraduationHat02Icon
      case 'channel':
        return Hash02Icon
      default:
        return Hash02Icon
    }
  })
</script>

<template>
  <div class="flex flex-col items-center justify-center py-6 px-4 bg-background">
    <div class="w-10 h-10 rounded-full flex items-center justify-center mb-2 bg-surface">
      <component :is="iconComponent" class="w-6 h-6 text-primary" />
    </div>
    <CPText size="xs" weight="semibold" class="text-body text-center">
      {{ message }}
    </CPText>
  </div>
</template>
